import React, { useState, useEffect } from 'react';
import { getProfilePhotoUrl } from '@/api/myProfile';

const AgentCard = ({ agent }) => {
  const [agentImage, setAgentImage] = useState({});
  const [logoStyle, setLogoStyle] = useState({});
  // Load agent images
  useEffect(() => {
    const loadAgentImages = async () => {
      const images = { photoUrl: null, logoUrl: null };
      
      if (agent?.photoPath) {
        try {
          // Extract userId from photoPath (e.g., "/U_20161103080622017/U_20161103080622017_PHOTO.png")
          const userId = agent.photoPath.split('/')[1];
          if (userId) {
            images.photoUrl = await getProfilePhotoUrl(userId, agent.photoPath);
          }
        } catch (error) {
          console.error('Error loading agent photo:', error);
        }
      }
      
      if (agent?.logoPath) {
        try {
          // Extract userId from logoPath (e.g., "/U_20161103080622017/U_20161103080622017_LOGO.png")
          const userId = agent.logoPath.split('/')[1];
          if (userId) {
            images.logoUrl = await getProfilePhotoUrl(userId, agent.logoPath);
          }
        } catch (error) {
          console.error('Error loading agent logo:', error);
        }
      }
      setAgentImage(images);
    };
    
    if (agent) {
      loadAgentImages();
    }
    
    // Cleanup blob URLs when component unmounts
    return () => {
      if (agentImage?.photoUrl || agentImage?.logoUrl) {
        if (agentImage?.photoUrl && agentImage?.photoUrl.startsWith('blob:')) {
          URL.revokeObjectURL(agentImage?.photoUrl);
        }
        if (agentImage?.logoUrl && agentImage?.logoUrl.startsWith('blob:')) {
          URL.revokeObjectURL(agentImage?.logoUrl);
        }
      }
    };
  }, [agent]);

  return (
    <div key={agent.id} className="agent-card">
      <div className="agent-photo">
        <img 
          src={agentImage?.photoUrl || '/assets/images/default_profile.png'} 
          alt={agent?.name}
          onError={(e) => {
            e.target.src = '/assets/images/default_profile.png';
          }}
        />
      </div>
      
      <div className="agent-info">
        <h4 className="agent-name">{agent?.name}</h4>
        
        <div className="contact-buttons">
          {agent?.email && (
            <a 
              href={`mailto:${agent?.email}`}
              className="contact-btn email-btn"
              title={`Send Email to ${agent.email}`}
              onClick={(e) => {
                window.location.href = `mailto:${agent?.email}`;
              }}
            >
              <img 
                src={'/assets/images/home/mail.png'} 
                alt='image mail'
              />
            </a>
          )}
          
          {agent?.phoneNumber && (
            <a 
              href={`tel:${agent.phoneNumber}`}
              className="contact-btn phone-btn"
              title={`Call ${agent.phoneNumber}`}
            >
              <img 
                src={'/assets/images/home/phone.png'} 
                alt='image phone'
              />
            </a>
          )}
          
          {agent?.website && (
            <a 
              href={agent?.website.startsWith('http') ? agent?.website : `https://${agent?.website}`}
              target="_blank"
              rel="noopener noreferrer"
              className="contact-btn website-btn"
              title="Visit Website"
            >
              <img 
                src={'/assets/images/home/globe.png'} 
                alt='image globe'
              />
            </a>
          )}
        </div>
        
        {agentImage?.logoUrl && <div className="company-logo">
          <img 
            src={agentImage?.logoUrl || '/assets/images/no-photo.jpg'} 
            alt="Company Logo"
            style={logoStyle}
            onLoad={(e) => {
              const { naturalWidth, naturalHeight } = e.target;
              const ratio = naturalWidth / naturalHeight;
              const isSmallScreen = window.innerWidth < 800;
              
              if (ratio > 7) {
                setLogoStyle({});
              } else {
                setLogoStyle({ height: isSmallScreen ? '23px' : '33px' });
              }
            }}
            onError={(e) => {
              e.target.src = '/assets/images/no-photo.jpg';
            }}
          />
        </div>}
      </div>
    </div>
  );
};

export default AgentCard;